import "bootstrap/dist/css/bootstrap.min.css";
import Table from "./component/table";
import "font-awesome/css/font-awesome.css";
import React from "react";

function App() {
  return (
    <React.Fragment >
      <Table />
    </React.Fragment>
  );
}

export default App;
